import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useApprovalSelection = () => {
  const { search } = useLocation();
  const [selectedId, setSelectedId] = useState<string | undefined>(
    () => new URLSearchParams(search).get('id') || undefined
  );
  useEffect(() => {
    setSelectedId(new URLSearchParams(search).get('id') || undefined);
  }, [search]);
  return [selectedId, setSelectedId] as const;
};
